// extracted by mini-css-extract-plugin
export default {"container":"p2-z","heading":"q2-z","links":"r2-z","copy":"s2-z","subCopy":"t2-z","linksLeft":"u2-z","linksCenter":"v2-z","linksRight":"w2-z","link":"x2-z","onlyLink":"y2-z"};